/*
 * @Author: hfxie
 * @Date: 2023-04-24 16:53:14
 * @LastEditors: hfxie
 * @LastEditTime: 2023-04-24 17:17:56
 * @Description: file content
 */
import Vue from "vue";
/*
  Tempalte内:
    v-clickDown="{
      'clickFun': 'handlerClickBar2',
      'clickFunType': task,
      'dblclickFun': 'handlerDBClickBar2',
      'dblclickFunType': task,
    }"
  Method内:
    handlerClickBar2(event, item) {
      console.log("单击", event, item);
    },
    handlerDBClickBar2(event, item) {
      console.log("双击", event, item);
    },
*/
const clickDown = Vue.directive("clickDown", {
  inserted(el, binding, vnode) {
    let clickTimer = null;
    // 单击
    el.addEventListener("click", (event) => {
      if (clickTimer) {
        window.clearTimeout(clickTimer);
        clickTimer = null;
      }
      clickTimer = setTimeout(() => {
        vnode.context[binding.value.clickFun](event, binding.value.clickFunType);
      }, 300);

    });

    // 双击
    el.addEventListener("dblclick", (event) => {
      if (clickTimer) {
        window.clearTimeout(clickTimer);
        clickTimer = null;
      }
      vnode.context[binding.value.dblclickFun](event, binding.value.dblclickFunType);
    });

  },
});



export default {
  clickDown,

};
